// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tos {
    box-sizing: border-box;
    max-width: 800px;
    min-width: 340px;
    width: 100%;

    font-size: 14px;
    line-height: 1.7em;
    margin: 0 auto;
}
.tos h1 {
    text-align: center;
}
.tos h2 {
    margin-top: 2em;
}
.tos h3 {
    margin-top: 1.5em;
}
.tos h4 {
    margin-top: 1em;
}
.tos li {
    padding: 0.25em 0;
}


.tos h2 a:link, .tos h2 a:active, .tos h2 a:visited {
    color: #333;
    text-decoration: none;
}
.tos h2 a:hover {
    color: #666;
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./client/components/about/TermsOfService/TermsOfService.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;;IAEX,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB","sourcesContent":[".tos {\n    box-sizing: border-box;\n    max-width: 800px;\n    min-width: 340px;\n    width: 100%;\n\n    font-size: 14px;\n    line-height: 1.7em;\n    margin: 0 auto;\n}\n.tos h1 {\n    text-align: center;\n}\n.tos h2 {\n    margin-top: 2em;\n}\n.tos h3 {\n    margin-top: 1.5em;\n}\n.tos h4 {\n    margin-top: 1em;\n}\n.tos li {\n    padding: 0.25em 0;\n}\n\n\n.tos h2 a:link, .tos h2 a:active, .tos h2 a:visited {\n    color: #333;\n    text-decoration: none;\n}\n.tos h2 a:hover {\n    color: #666;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
